// Notes Panel Component
// Collapsible notes section for the quote page

import { useState } from 'react'
import { useQuoteStore } from '../store'
import { FileText, Plus, Trash2, ChevronDown, ChevronUp, MessageSquare } from 'lucide-react'
import { EmptyState } from '@components/ui/EmptyState'

export function NotesPanel() {
  const { partnership, addPartnershipNote, removePartnershipNote } = useQuoteStore()
  const [isExpanded, setIsExpanded] = useState(false)
  const [newNote, setNewNote] = useState('')

  const handleAddNote = () => {
    if (newNote.trim()) {
      addPartnershipNote(newNote.trim())
      setNewNote('')
    }
  }

  return (
    <div className="bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-lg overflow-hidden">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-center justify-between p-4 hover:bg-[var(--bg-tertiary)] transition-colors"
      >
        <div className="flex items-center gap-3">
          <FileText className="text-primary" size={18} />
          <span className="font-medium text-[var(--text-primary)]">
            Notes {partnership.notes.length > 0 && `(${partnership.notes.length})`}
          </span>
        </div>
        {isExpanded ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
      </button>
      {isExpanded && (
        <div className="px-4 pb-4 space-y-3">
          {partnership.notes.length > 0 ? (
            partnership.notes.map((note, index) => (
              <div
                key={index}
                className="flex items-start gap-2 bg-[var(--bg-tertiary)] rounded-lg p-3"
              >
                <span className="text-sm text-[var(--text-primary)] flex-1">{note}</span>
                <button
                  onClick={() => removePartnershipNote(index)}
                  className="text-red-400 hover:text-red-300 transition-colors flex-shrink-0"
                >
                  <Trash2 size={16} />
                </button>
              </div>
            ))
          ) : (
            <EmptyState
              icon={MessageSquare}
              title="No notes yet"
              description="Add notes about this deal"
            />
          )}
          <div className="flex gap-2">
            <input
              type="text"
              value={newNote}
              onChange={(e) => setNewNote(e.target.value)}
              placeholder="Add a new note..."
              className="flex-1 px-3 py-2 bg-[var(--bg-tertiary)] border border-[var(--border-color)] rounded-md text-sm text-[var(--text-primary)]"
              onKeyDown={(e) => e.key === 'Enter' && handleAddNote()}
            />
            <button
              onClick={handleAddNote}
              disabled={!newNote.trim()}
              className="px-3 py-2 bg-primary text-white rounded-md hover:bg-primary/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <Plus size={18} />
            </button>
          </div>
        </div>
      )}
    </div>
  )
}
